
// import Patient from '../../Patient/Patient';
// import Claims from '../../Billing/Claims/Claims';
// import Payments from '../../Billing/Payments/Payments';
// import Report from '../../Reports/Report';
import { useDispatch } from 'react-redux';
import { TabActionPatient } from "../../../actions/PatientActions";
import { TabActionReports } from '../../../actions/ReportActions/ReportActions';
import { ClaimsRecordAction, TabActionClaims } from '../../../actions/BillingActions';
import { TabActionPayments } from '../../../actions/BillingActions';
import isNull from '../../../utils/NullChecking';
import { lazy } from 'react';
import Caregiver from '../../Caregiver/Caregiver';
import { TabActionCaregiver } from '../../../actions/CaregiverActions';
import { ChildCustomView } from '../../../actions/ChildCustomViewAction';

const Patient = lazy(() => import("../../Patient/Patient"))
const Claims = lazy(() => import("../../Billing/Claims/Claims"))
const Payments = lazy(() => import("../../Billing/Payments/Payments"))
const Report = lazy(() => import("../../Reports/Report"))

export const useOpenSideBar = (handleActive_SubTab) => {
  let dispatch = useDispatch();
  const handleOpen = (data) => {
    let dataProp = {
      id: data.data.id,
      name: data.data.name,
      time: new Date(),
      ...(data.data.checkType && { checkType: data.data.checkType }),
    };
    switch (data.name) {
      case "Patient":
        OpenPatients({ ...dataProp, isPateintSubTapOpen: true })
        break;
      case "Claims":
        dataProp['visitType'] = data.data.visitType
        dataProp['isClaimSubTapOpen'] = true
        dataProp['isFollowUp'] = data.data.isFollowUp
        dataProp['IsDeleted'] = data.data.IsDeleted
        dataProp['EncounterID'] = data.data.EncounterID
        dataProp['PatientID'] = data.data.PatientID
        if (data.data?.patientRecord) {
          dataProp['patientRecord'] = data?.data?.patientRecord
        }
        OpenClaims(dataProp, data.data.ClaimRecord)
        break;
      case "Reports":
        OpenReports(dataProp)
        break;
      case "Payments":
        dataProp['claimNumber'] = data?.data?.claimNumber;
        OpenPayments(dataProp)
        break;
      case "Caregiver":
        OpenCaregiver(dataProp)
        break;
      case "ChildCustomView":
        OpenChildCustomView(data)
        break;
      default:
        break;
    }
  }
  const handleObj = (name, dataProp) => {
    return (
      {
        key: 2,
        name: name,
        active: true,
        data: dataProp,
      }
    )
  }
  const OpenPatients = (dataProp) => {
    let objPatient = handleObj("Patient", dataProp);
    handleActive_SubTab(2, 'Patient', <Patient />, true)
    dispatch(TabActionPatient(objPatient))
  }
  const OpenClaims = (dataProp, ClaimsData) => {
    let objClaim = handleObj("Claims", dataProp);
    handleActive_SubTab(71, 'Claims', <Claims />, true)
    setTimeout(() => {
      dispatch(TabActionClaims(objClaim))
    }, 0);
    if (!isNull(ClaimsData)) {
      setTimeout(() => {
        dispatch(ClaimsRecordAction(ClaimsData))
      }, 0);
    }
  }
  const OpenPayments = (dataProp) => {
    let objPayment = handleObj("Payments", dataProp);
    handleActive_SubTab(73, 'Payments', <Payments />, true)
    dispatch(TabActionPayments(objPayment))
  }
  const OpenReports = (dataProp) => {
    let objReports = handleObj("Reports", dataProp);
    handleActive_SubTab(4, 'Reports', <Report />, true)
    dispatch(TabActionReports(objReports))
  }
  const OpenCaregiver = (dataProp) => {
    let objCaregiver = handleObj("Caregiver", dataProp);
    handleActive_SubTab(1001, 'Caregiver', <Caregiver />, true);
    dispatch(TabActionCaregiver(objCaregiver));
  }
  const OpenChildCustomView = (dataProp) => {
    console.log("OpenChildCustomView", dataProp);
    dispatch(ChildCustomView(dataProp));
  }
  return handleOpen;
}